import { style } from 'typestyle'
export const pl8 = style({ paddingLeft: '8px' })
